//Slider init
$('.slick').slick({
	dots: true,
	arrows: false
});


$('.video__slider').slick({
	dots: true,
	arrows: true,
	slidesToShow: 1,
  autoplay: false,
  autoplaySpeed: 5000
});

$('.video__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var current = $('.slick-current');
    current.html(current.html());
});



// WEBPACK FOOTER //
// ./src/js/slickSlider.js